export const pciEveryone = 'PCI.Everyone';
export const memberUser = 'External Web Users';
export const complianceAffiliate = 'Compliance Affiliate';
export const informationalAffiliate = 'Informational Affiliate';
export const servicePurchaser = 'Service Purchaser';
export const assessmentUser = 'Assessment User';
export const advocacyParticipationManager = 'Advocacy Participation Manager';
